"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Table_1 = __importDefault(require("@material-ui/core/Table"));
var TableBody_1 = __importDefault(require("@material-ui/core/TableBody"));
var DataGridMobileCellContent_1 = __importDefault(require("../DataGridMobileCellContent"));
var columns_1 = require("../../../context/columns");
var DataGridMobileCell = function (props) {
    var columnsState = (0, columns_1.useColumnsContext)().columnsState;
    return (react_1.default.createElement(Table_1.default, null,
        react_1.default.createElement(TableBody_1.default, null, columnsState.map(function (column) { return (react_1.default.createElement(DataGridMobileCellContent_1.default, __assign({ key: column.id, column: column }, props))); }))));
};
exports.default = DataGridMobileCell;
